export class RequestHelper {
    objectifyForm(formArray: any): object {
        let returnArray = {};
        for (let i = 0; i < formArray.length; i++){
            returnArray[formArray[i]['name']] = formArray[i]['value'];
        }
        return returnArray;
    }

    findGetParameter(parameterName: string): string {
        let result = null;
        const queryString = window.location.search.substring(1);
        const items = queryString.split("&");

        items.forEach(function (item) {
            const eqPos = item.indexOf("=");

            if (eqPos !== -1) {
                const key = item.substring(0, eqPos);
                const value = item.substring(eqPos + 1);

                if (key === parameterName) {
                    result = decodeURIComponent(value);
                }
            }
        });

        return result;
    }

    base64UrlSave(obj) {
        const data = JSON.stringify(obj);
        return btoa(data).replace(/\//g, '_').replace(/\+/g, '-');
    }

    postToUrl(path: string, data: any, options?: any) {
        if (options === undefined) {
            options = {};
        }

        let method = options.method || "post"; // Set method to post by default if not specified.

        let form = document.createElement("form");
        form.setAttribute("method", method);
        form.setAttribute("action", path);

        function constructElements(item, parentString) {
            if (typeof item == "function") return;

            if (typeof item != "object") {
                createInput(parentString.slice(0, -1), item);
            }

            for (let key in item) {
                if (item.hasOwnProperty(key) && item[key] != null && typeof item[key] != 'function') {
                    if (Object.prototype.toString.call(item[key]) === '[object Array]') {
                        for (let i = 0; i < item[key].length; i++) {
                            constructElements(item[key][i], parentString + key + "[" + i + "].");
                        }
                    } else if (Object.prototype.toString.call(item[key]) === '[object Object]') {
                        constructElements(item[key], parentString + key + ".");
                    } else {
                        createInput(parentString + key, item[key]);
                    }
                }
            }

            function createInput(name: string, value: string) {
                let hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", name);
                hiddenField.setAttribute("value", value);
                form.appendChild(hiddenField);
            }
        }

        //if the parent 'data' object is an array we need to treat it a little differently
        if (Object.prototype.toString.call(data) === '[object Array]') {
            if (options.arrayName === undefined) console.warn("Posting array-type to url will doubtfully work without an arrayName defined in options.");
            //loop through each array item at the parent level
            for (let i = 0; i < data.length; i++) {
                constructElements(data[i], (options.arrayName || "") + "[" + i + "].");
            }
        } else {
            //otherwise treat it normally
            constructElements(data, "");
        }

        document.body.appendChild(form);
        form.submit();
    };

    insertParam(url: string, key: string, value: string) {
        let absolutePath = this.absolutePath(url);
        let urlObj = new URL(absolutePath);
        urlObj.searchParams.append(key, value);
        return urlObj.toString();
    }

    absolutePath(href) {
        let link = document.createElement("a");
        link.href = href;
        return link.href;
    }

    getFullUrl(href: string) {
        const origin = window.location.origin || `${window.location.protocol}//${window.location.host}`;
        if (!href) return origin;
        if (href[0] === '/') {
            return `${origin}${href}`;
        } else {
            return `${origin}/${href}`;
        }
    }

    /**
     * Extracts the last three numeric route parameters (projNr, secondNr, thirdNr) from a given URL string.
     * Handles double slashes, query parameters, and hashes.
     * Returns a labeled tuple: [projNr, secondNr, thirdNr] or null.
     * if the extraction fails or if the parameters are not valid real numbers.
     */
    public getEntityTripleFromUrl(url: string): [projNr: number, secondNr: number, thirdNr: number] | null {
        if (!url) return null;

        const cleanPath = url.split('?')[0].split('#')[0];
        const segments = cleanPath.split('/').filter(segment => segment.trim() !== '');

        if (segments.length < 3) return null;

        const [rawProj, rawSecond, rawThird] = segments.slice(-3);

        const projNr = Number(rawProj);
        const secondNr = Number(rawSecond);
        const thirdNr = Number(rawThird);

        if (!Number.isFinite(projNr) || !Number.isFinite(secondNr) || !Number.isFinite(thirdNr)) return null;

        return [projNr, secondNr, thirdNr];
    }
}